import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Pagination from '../Pagination'
import { updateStateSiswaAttendance } from '../../features/siswaAttendanceHistorySlice'
import orangImage from '../../assets/images/user-foto.png'
import imgErrorValidation from '../../utils/imgErrorValidation'

let PageSize = 10;

function Table() {
    const { list, isLoading, currentPage } = useSelector(state => state.siswaAttendanceHistory)
    const dispatch = useDispatch()

    const currentTableData = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize
        const lastPageIndex = firstPageIndex + PageSize
        return list?.slice(firstPageIndex, lastPageIndex)
    }, [list, currentPage])

    return (
        <>
            <table className='table'>
                <thead>
                    <tr>
                        <th className='th-niy'>NIY</th>
                        <th className='th-name'>Nama Siswa</th>
                        <th className='th-jabatan'>Kelas</th>
                        <th className='th-jabatan'>Tanggal</th>
                        <th className='th-jabatan'>Waktu Masuk</th>
                        <th className='th-jabatan'>Waktu Pulang</th>

                    </tr>
                </thead>
                <tbody>
                    {isLoading
                        ? <tr className='loading loading-table'><td>loading...</td></tr>
                        : currentTableData?.length === 0
                            ? <tr className='loading-table'><td>Data tidak ditemukan</td></tr>
                            : currentTableData?.map((item, key) => (
                                <tr key={key}>
                                    <td className='niy-col'>{item?.student?.niy}</td>
                                    <td className='row-img'>
                                        <img src={orangImage} onError={imgErrorValidation} alt="" />
                                        {item?.student?.nama}
                                    </td>
                                    <td>{item?.kelas}</td>
                                    <td>{item?.tanggal_masuk}</td>
                                    <td style={{color: item?.isvld_wkt_masuk ?"#3661EBFF":"#ff0000"}}>{item?.waktu_masuk}</td>
                                    <td style={{color: item?.isvld_wkt_pulang ?"#3661EBFF":"#ff0000"}}>{item?.waktu_pulang || '-'}</td>

                                </tr>
                            ))
                    }
                </tbody>
            </table>

            {!isLoading && (
                <Pagination
                    className="pagination-bar"
                    currentPage={currentPage}
                    totalCount={list?.length}
                    pageSize={PageSize}
                    onPageChange={page => dispatch(updateStateSiswaAttendance({ name: 'currentPage', value: page }))}
                />
            )}
        </>
    )
}

export default Table
